import React from 'react'
import useGetLiveModelScores from '../hooks/useGetLiveModelScores';
import { Table, TBody, TD, TH, THead, TR } from '@sede-enterprise/shell-ds-react-framework';
import { formatClassification } from '../../../util/formatClassification';
import useGetTrainModelScores from '../hooks/useGetTrainModelScores';

const Scores = ({ id, currTab, list, modelId }) => {

    const { data } = useGetLiveModelScores(id, currTab, list)
    const { data: trainData } = useGetTrainModelScores(id, modelId, currTab, list)
    return (
        <div>
            <Table>
                <THead>
                    <TR>
                        <TH></TH>
                        <TH>Train</TH>
                        <TH>Live</TH>
                    </TR>
                </THead>
                <TBody>
                    <TR>
                        <TH>MSE</TH>

                        <TD className='data-value'>{trainData?.mse ? trainData.mse.toFixed(3) : "-"}</TD>
                        <TD className='data-value'>{data?.mse ? data.mse.toFixed(3) : "-"}</TD>
                    </TR>
                    <TR>
                        <TH>R2</TH>

                        <TD className='data-value'>{trainData?.r2 ? trainData.r2.toFixed(3) : "-"}</TD>
                        <TD className='data-value'>{data?.r2 ? data.r2.toFixed(3) : "-"}</TD>
                    </TR>
                    <TR>
                        <TH>R2 WT</TH>

                        <TD className='data-value'>{trainData?.r2WT ? trainData.r2WT.toFixed(3) : "-"}</TD>
                        <TD className='data-value'>{data?.r2WT ? data.r2WT.toFixed(3) : "-"}</TD>
                    </TR>
                    <TR>
                        <TH>Rating</TH>

                        <TD className='data-value'>{trainData?.rating ? formatClassification(trainData.rating) : "-"}</TD>
                        <TD className='data-value'>{data?.rating ? formatClassification(data.rating) : "-"}</TD>
                    </TR>
                </TBody>
            </Table>
        </div>
    )
}

export default Scores